// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sc-9";
export var arrowButtonContainer = "_sc-5";
export var arrowButtonIcon = "_sc-6";
export var carouselArrowButton = "_sc-2";
export var carouselElementContainer = "_sc-1";
export var currentSlide = "_sc-8";
export var left = "_sc-3";
export var otherSlide = "_sc-a";
export var productCarouselContainer = "_sc-0";
export var right = "_sc-4";
export var sliderOverflow = "_sc-7";